<template>
  <b-overlay :show="showOverlay ">
    <b-col class="mb-1 bg-white p-0" cols="12">
      <DynamicBreadCrumb :items="pageBreadcrumb"></DynamicBreadCrumb>
    </b-col>
    <b-modal
        id="modal-delete"
        cancelTitle="Cancel"
        centered
        ok-title="Delete"
        title="Delete Product Slider"
        @ok.prevent="deleteProductSlider"
    >
      <div class="row">
        <div class="col-md-12">
          <span>Are you sure you want to delete this Product Slider ?</span>
        </div>
      </div>
    </b-modal>
    <template>
      <b-card class="data-edit-wrapper">
        <validation-observer ref="updateProductSlider" class="div">
          <b-row>
            <b-col cols="12">
              <b-row>
                <b-col class="my-1" cols="12">
                  <strong>add Range Ratio</strong>
                </b-col>
                <b-col md="4">
                  <b-form-group
                      label="Minimum Selected Features"
                  >
                    <b-form-input
                        id="data-edit-seoTitle"
                        v-model="incrementalRatioDTO.start"
                        type="number"

                    />
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group
                      label="Maximum Selected Features"
                  >
                    <b-form-input
                        id="data-edit-seoTitle"
                        v-model="incrementalRatioDTO.end"
                        type="number"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group
                      label="Amount Added To Order (%)"
                  >
                    <b-form-input
                        maxlength="2"
                        id="data-edit-seoTitle"
                        v-model="incrementalRatioDTO.percent"
                        type="text"
                    />
                  </b-form-group>
                </b-col>

                <b-col class="d-flex align-items-center justify-content-start my-1" cols="3">
                  <b-button
                      variant="primary"
                      @click="createIncrementalRatio"
                  >
                    <span class="ml-25 align-middle">Add</span>
                  </b-button>
                </b-col>
                <b-col v-if="ratios && ratios.length>0" class="d-flex align-items-center flex-wrap"
                       cols="12"
                >
                  <b-badge v-for="(item,idx) in ratios" :key="idx"
                           class="d-flex align-items-center  m-25" variant="primary"
                  >
                    <div class="mr-1">
                      <span>Min Features : </span>
                      <span>{{ item.start }}</span>
                    </div>
                    <div v-if="item.end" class="mr-1">
                      <span>Max Features : </span>
                      <span>{{ item.end }} </span>
                    </div>
                    <div v-if="item.percent" class="mr-1">
                      <span>Added Value To Order : </span>
                      <span>{{ item.percent }} %</span>
                    </div>
                    <feather-icon class="cursor-pointer" icon="XIcon" @click="deleteDiscount(item)"></feather-icon>
                  </b-badge>

                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </validation-observer>
      </b-card>
    </template>
  </b-overlay>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import { BBadge, BButton, BCard, BCol, BForm, BFormGroup, BFormInput, BModal, BOverlay, BRow, } from 'bootstrap-vue'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import ckEditorMain from '@/views/components/ckEditorMain'
import Helper from '@/libs/Helper'
import MediaHandler from '@/views/components/utilities/MediaHandler.vue'
import Debouncer from '@/views/components/debouncer.vue'
import DynamicBreadCrumb from '@/views/components/utilities/DynamicBreadCrumb.vue'
import {
  CreateIncrementalRatio,
  DeleteIncrementalRatio,
  GetAllIncrementalRatioByProductId
} from '@/libs/Api/OrderIncrementalRatio'

export default {
  components: {
    DynamicBreadCrumb,
    Debouncer,
    MediaHandler,
    BForm,
    ValidationProvider,
    ValidationObserver,
    ckEditorMain,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BButton,
    BBadge,
    BOverlay,
    BModal,
    vSelect,
  },
  name: 'manage-slider',
  title: 'manage slider',
  data() {
    return {
      required,
      showOverlay: false,
      baseUrl: Helper.baseUrl,
      ratios: null,
      selectedGameServiceCategory: null,
      currentPage: 1,
      sortBy: '',
      perPage: 10,
      gameServiceCategories: null,
      searchQuery: '',
      totalCount: null,
      pageBreadcrumb: [
        {
          text: 'Manage Games',
          href: '/apps/games/manage-games',
          active: false
        },
        {
          text: `Manage Game`,
          href: `/apps/games/manage-game?gameId=${this.$route.query.gameId}`,
          active: false
        },
        {
          text: `Manage Game Service Category`,
          href: `/apps/games/game-service-categories/manage-game-service-category?gameId=${this.$route.query.gameId}&gameServiceCategoryId=${this.$route.query.gameServiceCategoryId}`,
          active: false
        },
        {
          text: `Manage Game Service`,
          href: `/apps/games/game-service-categories/game-service/manage-game-services?gameId=${this.$route.query.gameId}&gameServiceCategoryId=${this.$route.query.gameServiceCategoryId}&gameServiceId=${this.$route.query.gameServiceId}`,
          active: false
        },
        {
          text: `Manage Product`,
          href: `/apps/games/game-service-categories/game-service/products/manage-product?gameId=${this.$route.query.gameId}&gameServiceCategoryId=${this.$route.query.gameServiceCategoryId}&gameServiceId=${this.$route.query.gameServiceId}&productId=${this.$route.query.productId}`,
          active: false
        },
        {
          text: `Manage Product Incremental Ratio`,
          href: `/apps/games/game-service-categories/game-service/products/product-incremental-ratio/manage?gameId=${this.$route.query.gameId}&gameServiceCategoryId=${this.$route.query.gameServiceCategoryId}&gameServiceId=${this.$route.query.gameServiceId}&productId=${this.$route.query.productId}`,
          active: true
        },
      ],
      myTableColumns: [
        {
          key: 'id',
          label: '#',
          sortable: true
        },
        {
          key: 'title',
          label: 'title',
          sortable: true
        },
        {
          key: 'subTitle',
          label: 'subTitle',
          sortable: true
        },
        {
          key: 'operation',
          label: 'operation'
        },
      ],
      incrementalRatioDTOValidations: ['start', 'end', 'percent'],
      incrementalRatioDTO: {
        start: null,
        end: null,
        percent: null,
        productId: 0
      },
      createSlider: {
        productId: this.$route.query.productId,
        minValue: null,
        maxValue: null,
        title: null,
        defaultValue: null,
        productSliderDiscountDtos: []
      },
      sliderDiscounts: null,

    }
  },

  async created() {
    await Promise.all([
      this.getProductIncrementalRatiosByProductId(),
    ])
  },
  methods: {
    async createIncrementalRatio() {
      let _this = this
      let isValid = true
      _this.incrementalRatioDTOValidations.forEach((validation) => {
        if (!_this.incrementalRatioDTO[validation]) {
          isValid = false
        }
      })
      if (isValid) {
        _this.showOverlay = true
        let createIncrementalRatio = new CreateIncrementalRatio(_this)
        _this.incrementalRatioDTO.productId = _this.$route.query.productId
        createIncrementalRatio.setParams(_this.incrementalRatioDTO)
        await createIncrementalRatio.fetch(function (content) {
          _this.$toast({
            component: ToastificationContent,
            props: {
              title: `success`,
              icon: 'CheckIcon',
              variant: 'success',
              text: `Ratio created successfully`,
            },
          })
          _this.incrementalRatioDTO = {
            start: null,
            end: null,
            percent: null,
            productId: 0
          }
          _this.getProductIncrementalRatiosByProductId()
          _this.showOverlay = false
        }, function (error) {
          _this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: {
              text: error.message,
              title: `error`,
              variant: 'danger',
            },
          })
          _this.showOverlay = false
        })

      } else {
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            text: 'Please Fill In All The Fields.',
            title: `error`,
            variant: 'danger',
          },
        })
      }
    },
    async deleteDiscount(item) {
      let _this = this
      _this.showOverlay = true
      let deleteIncrementalRatio = new DeleteIncrementalRatio(_this)
      deleteIncrementalRatio.setId(item.id)
      await deleteIncrementalRatio.fetch(function (content) {
        _this.$toast({
          component: ToastificationContent,
          props: {
            title: `success`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `Ratio Deleted Successfully`,
          },
        })
        _this.getProductIncrementalRatiosByProductId()
        _this.showOverlay = false
      }, function (error) {
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            text: error.message,
            title: `error`,
            variant: 'danger',
          },
        })
        _this.showOverlay = false
      })

    },
    async getProductIncrementalRatiosByProductId() {
      let _this = this
      _this.showOverlay = true
      let getAllIncrementalRatioByProductId = new GetAllIncrementalRatioByProductId(_this)
      let data = {
        productId: _this.$route.query.productId
      }
      getAllIncrementalRatioByProductId.setParams(data)
      await getAllIncrementalRatioByProductId.fetch(function (content) {
        _this.showOverlay = false
        _this.ratios = content.data
      }, function (error) {
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            text: error.message,
            title: `error`,
            variant: 'danger',
          },
        })
        _this.showOverlay = false
      })
    },
  }
}
</script>

<style scoped>

</style>
